module.exports = __webpack_public_path__ + "static/seo-9f7d1d3b533f8ab3c951cdb42e928b3e.jpg";